export const ACTIVITY_HANDLES = {
	LEFT_SOURCE: 'left-s',
	LEFT_TARGET: 'left-t',
	TOP_SOURCE: 'top-s',
	TOP_TARGET: 'top-t',
	RIGHT_SOURCE: 'right-s',
	RIGHT_TARGET: 'right-t',
	BOTTOM_SOURCE: 'bottom-s',
	BOTTOM_TARGET: 'bottom-t',
} as const;
